import { render, staticRenderFns } from "./OrderItemComments.vue?vue&type=template&id=438e5308&scoped=true&"
import script from "./OrderItemComments.vue?vue&type=script&lang=js&"
export * from "./OrderItemComments.vue?vue&type=script&lang=js&"
import style0 from "./OrderItemComments.vue?vue&type=style&index=0&id=438e5308&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "438e5308",
  null
  
)

export default component.exports